import { AsYouType, isPossiblePhoneNumber } from 'libphonenumber-js';

export const formatContactPhoneNumber = (
  phone: string | null | undefined,
): string => {
  if (!phone) {
    return '';
  }

  return new AsYouType().input(`+${phone.replace(/\D/g, '')}`);
};

export const isPossibleContactPhoneNumber = (phone: string): boolean => {
  return isPossiblePhoneNumber(formatContactPhoneNumber(phone));
};

export const normalizeContactPhoneNumber = (input: string): string => {
  return input.replace(/\D/g, '');
};
